import React from 'react';
import '../styles/common.css';
import {FormattedMessage, useIntl} from 'react-intl';

import logo_fi_lvv from '../images/LVV_suomi_nega.svg';
import logo_sv_lvv from '../images/LVV_suomi-ruotsi_nega.svg';

const Footer = props => {
  const {lvvEnabled} = props;
  const d = new Date();
  const currentYear = d.getFullYear();

  const intl = useIntl();
  const copyrightLink = intl.formatMessage({id: 'copyrightLink'});
  const fillInApplicationLink = intl.formatMessage({id: 'fillInApplicationLink'});
  const contactInformationLink = intl.formatMessage({id: 'contactInformationLink'});
  const privacyPolicyLink = intl.formatMessage({id: 'privacyPolicyLink'});
  const readMoreAboutDebtCollectionLink = intl.formatMessage({id: 'readMoreAboutDebtCollectionLink'});

  const oldFooter = () => {
    return (
      <footer className="footer">
        <p>
          <FormattedMessage id="footer-read_more_info" defaultMessage="Lue lisää" />{' '}
          {lvvEnabled ? (
            <a
              style={{textDecoration: 'underline'}}
              href={intl.locale === 'fi' ? 'lvv-placeholder' : 'lvv-placeholder-sv'}
            >
              <FormattedMessage id="footer-read_more_info_lvv" defaultMessage="lvv-placeholder" />
            </a>
          ) : (
            <a
              style={{textDecoration: 'underline'}}
              href={
                intl.locale === 'fi'
                  ? 'https://avi.fi/asioi/yritys-tai-yhteiso/valvonta-ja-kantelut/raha-ja-omaisuus/perintatoimistot'
                  : 'https://avi.fi/sv/valj-arende/foretag-eller-organisation/tillsyn-och-klagomal/pengar-och-formogenhet/tillsyn-av-indrivningsverksamhet'
              }
            >
              <FormattedMessage
                id="footer-read_more_info_avi"
                defaultMessage="aluehallintoviraston"
              />
            </a>
          )}{' '}
          <FormattedMessage id="footer-read_more_info_pages" defaultMessage="sivuilta" /> |{' '}
          <a
            style={{textDecoration: 'underline'}}
            href={lvvEnabled ? 'lvv-placeholder' : 'http://www.avi.fi/web/avi/tietosuoja'}
          >
            <FormattedMessage id="footer-data_protection" defaultMessage="Tietosuoja" />
          </a>
          | <FormattedMessage id="footer-fill_application_info" defaultMessage="Täytä hakemus" />{' '}
          <a style={{textDecoration: 'underline'}} href="https://sahkoinenasiointi.ahtp.fi">
            <FormattedMessage id="footer-fill_application_link" defaultMessage="Täältä" />
          </a>
        </p>
        <p>
          © {currentYear}{' '}
          {lvvEnabled ? (
            <FormattedMessage id="general_lvv" defaultMessage="lvv-placeholder" />
          ) : (
            <FormattedMessage id="general_avi" defaultMessage="Aluehallintovirasto" />
          )}
        </p>
      </footer>
    );
  };

  const newFooter = () => {
    return (
      <footer style={{width: '100%'}}>
        <div style={{flexDirection: 'column'}}>
          <div
            style={{
              backgroundColor: 'var(--colors-keskivihrea, #358273)',
              display: 'flex',
              color: 'white',
              paddingTop: '24px',
              paddingLeft: '80px',
              gap: '64px',
              paddingBottom: '1.6rem'
            }}
            className="flex-column flex-md-row"
          >
            <img
              className={intl.locale === 'fi' ? 'logo__fi' : 'logo__sv'}
              alt={'lvv-placeholder'}
              src={intl.locale === 'fi' ? logo_fi_lvv : logo_sv_lvv}
              style={{marginTop: '2rem'}}
            />
            <div style={{flexDirection: 'column'}}>
              <p className="body-lg-bold" style={{color: 'white'}}>
                <FormattedMessage id="additionalInfoAndLinks" />
              </p>
              <p style={{overflowWrap: 'anywhere'}}>
                <a className="link-sm" href={readMoreAboutDebtCollectionLink}>
                  <FormattedMessage id="readMoreAboutDebtCollection1" />
                </a>
                {' '}
                <FormattedMessage id="readMoreAboutDebtCollection2" />
              </p>
              <p style={{overflowWrap: 'anywhere'}}>
                <a className="link-sm" href={fillInApplicationLink}>
                  <FormattedMessage id="fillInApplication1" />
                </a>
                {' '}
                <FormattedMessage id="fillInApplication2" />
              </p>
              <p>
                <a className="link-sm" href={contactInformationLink}>
                  <FormattedMessage id="contactInformation" />
                </a>
              </p>
            </div>
          </div>
          <div
            style={{
              minHeight: '58px',
              backgroundColor: 'var(--colors-tummansininen, #00008e)',
              color: 'white'
            }}
          >
            <div
              style={{
                maxWidth: '460px',
                height: 'auto',
                margin: '0 auto',
                position: 'relative',
                display: 'flex',
                paddingTop: '16px',
                paddingBottom: '0.6rem'
              }}
              className="flex-column flex-sm-row justify-content-center align-items-center"
            >
              <a className="link-sm" href={privacyPolicyLink}>
                <FormattedMessage id="privacyPolicy" />
              </a>
              <p style={{marginLeft: '16px', marginRight: '16px', marginTop: '12px'}} className="d-none d-sm-block">|</p>

              <a className="link-sm" href={copyrightLink}>
                <FormattedMessage id="copyright" />
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  };

  return lvvEnabled ? newFooter() : oldFooter();
};

export default Footer;
